import { render } from "./ReflectionPage.vue?vue&type=template&id=b7b8e648"
import script from "./ReflectionPage.vue?vue&type=script&lang=js"
export * from "./ReflectionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__